<template>
	<div class="select">
		<select v-model="hospitalid">
			<option :value="0">-</option>
			<option
				v-for="option in hospitals"
				:key="option.id"
				:value="option.id"
				v-text="option.name"
			/>
		</select>
	</div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
	name: "HospitalFilter",
	props: {
		showempty: {
			type: Boolean,
			default: () => false
		}
	},
	computed: {
		...mapGetters({
			hospitals: "reportFilters/hospitals",
			hospitalID: "reportQueries/hospitalID"
		}),
		hospitalid: {
			get() {
				return this.hospitalID;
			},
			set(hospitalID) {
				this.setHospitalID(hospitalID);
			}
		}
	},
	async created() {
		if (!this.hospitals.length) {
			const { id } = this.hospitals[0];
			this.setHospitalID(id);
		}
	},
	methods: {
		...mapActions({
			setHospitalID: "reportQueries/updateHospitalID"
		})
	}
};
</script>

<style></style>
